import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { combineLatest, Observable, of, switchMap, tap } from "rxjs";
import { User } from "../user/user.types";
import { AppConstants } from "../constants/constants";
import { UserState } from './../user/state/user.state';

@Injectable()
export class AuthService {
    private _authenticated: boolean = false;
    public _resetPassVariableFlow: any = {};
    public _signUpVariableFlow: any = {};
    public _emailVerificationInfoVariable: any = {};
    public _verificationState: any = {}
    public _verifyNewDeviceVariableFlow: any = {}
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
    ) {
        //get reset data from session storge
        let storedResetData: any = JSON.parse(
            sessionStorage.getItem(AppConstants.PRISISTED_KEYS.RESET_PASS)
        );
        if (storedResetData) this._resetPassVariableFlow = storedResetData;

        //get sign up data from session storge

        let storedsignUpData: any = JSON.parse(
            localStorage.getItem(AppConstants.PRISISTED_KEYS.SIGNUP_DATA)
        );
        if (storedsignUpData) this._signUpVariableFlow = storedsignUpData;

        // get userId in case new device login 
        let storedNewDeviceData: string = sessionStorage.getItem('userId')
        if (storedNewDeviceData) this._verifyNewDeviceVariableFlow.userId = storedNewDeviceData;

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------
    /**
     * Setter & getter for access token
     * @param token
     */
    set accessToken(token: string) {
        localStorage.setItem(AppConstants.PRISISTED_KEYS.ACCESS_TOKEN, token);
    }

    get accessToken(): string {
        return localStorage.getItem(AppConstants.PRISISTED_KEYS.ACCESS_TOKEN) ?? "";
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     *
     * @param credentials
     * @param macAddress
     */

    signIn(credentials: any, macAddress: string): Observable<User> {
        const url = `${AppConstants.API.USERS_API}/auth`;
        const body = new HttpParams()
            .set("userName", credentials.email)
            .set("password", credentials.password)
            .set('macAddress', macAddress)
        // .set('sourceChannel', 'ADMINISTRATION_PORTAL')

        return this._httpClient
            .post(url, body.toString(), {
                headers: new HttpHeaders().set(
                    "Content-Type", "application/x-www-form-urlencoded"
                ),
            }).pipe(
                tap((res: any) => {
                    // Store the access token in the local storage
                    this.accessToken = res.accessToken;
                    // Set the authenticated flag to true
                    this._authenticated = true;
                    // Store the user on the user state
                    UserState.setUserState(res)
                    return of(true)
                })
            );
    }

    /**
     * Sign out
     */
    signOut(): Observable<boolean> {
        // Remove the access token from the local storage
        localStorage.removeItem(AppConstants.PRISISTED_KEYS.ACCESS_TOKEN);
        localStorage.removeItem(AppConstants.PRISISTED_KEYS.CURRENT_USER);
        localStorage.removeItem(AppConstants.PRISISTED_KEYS.USER_PERMISSIONS);
        localStorage.removeItem(AppConstants.PRISISTED_KEYS.ACCOUNT_STATUS);
        // Set the authenticated flag to false
        this._authenticated = false;

        // Return the observable
        return of(true);
    }


    /**
* invitation SignUp
*
* @param token
*/

    claimTokenInfo(token: string) {
        const url = `${AppConstants.API.CLAIM_TOKEN_API}/${token}`
        return this._httpClient.get(url)
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean> {
        // Check if the user is logged in
        if (this._authenticated) {
            return of(true);
        }

        // Check the access token availability
        if (!this.accessToken) {
            return of(false);
        }

        // Check the access token expire date
        // if (AuthUtils.isTokenExpired(this.accessToken)) {
        //     return of(false);
        // }
        // If the access token exists and it didn't expire, sign in using it
        return of(true);
    }

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: User): Observable<boolean> {
        const url = `${AppConstants.API.USERS_API}/forgotPassword`;
        return this._httpClient.post<boolean>(url, email).pipe(
            switchMap((response: any) => {
                // store email in collect Data Service
                this._resetPassVariableFlow.email = email.email;
                sessionStorage.setItem(AppConstants.PRISISTED_KEYS.RESET_PASS, JSON.stringify(this._resetPassVariableFlow));
                return of(response);
            })
        );
    }

    /**
     * Reset password
     *
     * @param resetPassForm
     */
    resetPassword(resetPassForm: any, resetToken: string): Observable<any> {
        const url = `${AppConstants.API.USERS_API}/resetPassword`;
        const body = new HttpParams()
            .set("password", resetPassForm.password)
            .set("confirmPassowrd", resetPassForm.cpassword);

        return this._httpClient.post(url, body, {
            headers: new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("token", resetToken),
        });
    }

    //confirmOtp

    /**
 * Reset password
 *
 * @param otp
 */
    confirmOtp(otp: string): Observable<any> {
        let url
        if (this._verificationState.verificationType == 'signup-mobile' || this._verificationState.verificationType == 'invite-mobile') {
            //send otp to mobile number coming from registration
            url = `${AppConstants.API.USERS_REGESTRATION_API}/${this._signUpVariableFlow.signUpRegRequestId}/otp/${otp}`;
        } else if (this._verificationState.verificationType == 'reset-pass') {
            //send otp to email coming from forgot password
            url = `${AppConstants.API.USERS_API}/${this._resetPassVariableFlow.userId}/otp/${otp}/status`;
            return this._httpClient.get(url, {})
        } else {
            //verify otp sent to email to verify new macAddress coming from new device
            url = `${AppConstants.API.USERS_API}/${this._verifyNewDeviceVariableFlow.userId}/otp/${otp}`;
        }
        //auto login if coming from registration or new device

        if (this._verificationState.verificationType == 'newDevice') {
            return this._httpClient.post(url, {}).pipe(
                tap((res: any) => {
                    // Store the access token in the local storage
                    this.accessToken = res.accessToken;
                    // Set the authenticated flag to true
                    this._authenticated = true;
                    // Store the user on the user state
                    // localStorage.setItem(AppConstants.PRISISTED_KEYS.ACCOUNT_STATUS, res .status.value);
                    UserState.setUserState(res)

                    return of(true)
                })
            );
        } else {
            return this._httpClient.post(url, {})
        }
    }

    /**
     * resend Otp
     * @param id
     */
    resendOtp(id: string): Observable<any> {
        let url
        if (this._verificationState.verificationType == 'signup-mobile') {
            //resend otp to mobile number
            url = `${AppConstants.API.USERS_API}/registration/${this._signUpVariableFlow.signUpRegRequestId}/otp/resend`;
        } else {
            //resend otp to email
            url = `${AppConstants.API.USERS_API}/${id}/otp/resend`;
        }
        return this._httpClient.get(url, {});
    }

    /**
 * Resend Verification Email
 */
    resendVerificationEmail() {
        let url = `${AppConstants.API.USERS_REGESTRATION_API}/${this._signUpVariableFlow.signUpRegRequestId}/email/resend`;
        return this._httpClient.post(url, {})
    }


    /**
     * activate Account
     * @param token
     */
    activateAccount(token: string): Observable<any> {
        const url = `${AppConstants.API.USERS_REGESTRATION_API}/email/verification?token=${token}`;
        return this._httpClient.post(url, {}, {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/x-www-form-urlencoded')
        })
    }
}
